// extracted by mini-css-extract-plugin
export default {"mDiv":"Services_mDiv__JS36-","conDiv":"Services_conDiv__zQCfU","fullS":"Services_fullS__2sOg7","detSer":"Services_detSer__9gMo9","title":"Services_title__4eIi0"};